var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06714 0.936771C6.252 -0.332726 8.93755 -0.310537 11.1019 0.994894C13.245 2.32691 14.5475 4.70418 14.5354 7.26144C14.4855 9.80194 13.0888 12.19 11.343 14.0361C10.3354 15.1064 9.20814 16.0528 7.98436 16.856C7.85833 16.9289 7.72027 16.9777 7.57701 17C7.43912 16.9941 7.30484 16.9534 7.18628 16.8814C5.31795 15.6746 3.67886 14.134 2.34785 12.334C1.23411 10.8314 0.601357 9.01601 0.535522 7.13442L0.540509 6.86069C0.631445 4.40464 1.96032 2.16093 4.06714 0.936771ZM8.44279 5.03477C7.55459 4.65723 6.53057 4.86235 5.84884 5.55435C5.16711 6.24635 4.96216 7.28872 5.32969 8.19478C5.69721 9.10084 6.5647 9.69184 7.52713 9.69185C8.15763 9.69638 8.76371 9.44383 9.21033 8.99048C9.65695 8.53712 9.90701 7.92064 9.90478 7.27838C9.90813 6.29804 9.33098 5.41231 8.44279 5.03477Z",
    fill: "#39B586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.c5c71b1a19530540dfa4b6409f602f15.svg";
export { ForwardRef as ReactComponent };